module.exports = __webpack_public_path__ + "static/media/for-startup-programs-five.fcf06c75.jpg";